import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AttachmentsSection } from "@/components/rdo/AttachmentsSection";
import { DialogAnexos } from "@/components/rdo/DialogAnexos";
import { Paperclip, Plus } from "lucide-react";

type LegacyAttachmentsSectionProps = {
  value: any;
  onChange: (v: any) => void;
  mode: "edit" | "view";
  // Legacy props for compatibility
  showAttachmentModal?: boolean;
  setShowAttachmentModal?: (show: boolean) => void;
  handleDeleteAttachment?: (index: number) => void;
  isEditing?: boolean;
  isSectionEnabled?: (section: string) => boolean;
};

export function LegacyAttachmentsSection({
  value,
  onChange,
  mode,
  showAttachmentModal = false,
  setShowAttachmentModal = () => {},
  handleDeleteAttachment = () => {},
  isEditing = false,
  isSectionEnabled = () => true,
}: LegacyAttachmentsSectionProps) {
  if (!isSectionEnabled('anexos')) {
    return null;
  }

  return (
    <>
      <Card data-section="attachments">
        <CardHeader className="pb-3">
          <CardTitle className="text-lg flex items-center gap-2">
            <Paperclip className="w-5 h-5" />
            Anexos ({(value || []).length})
            {isEditing && mode !== "view" && (
              <Button 
                onClick={() => setShowAttachmentModal(true)} 
                size="sm" 
                variant="outline" 
                className="ml-2"
              >
                <Plus className="w-4 h-4 mr-2" />
                Adicionar Anexos
              </Button>
            )}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <AttachmentsSection 
            attachments={(value || []) as any[]} 
            onDelete={handleDeleteAttachment}
          />
        </CardContent>
      </Card>

      {/* Legacy Dialog */}
      <DialogAnexos 
        open={showAttachmentModal}
        onOpenChange={setShowAttachmentModal}
        onSave={(attachments) => {
          onChange(attachments);
          setShowAttachmentModal(false);
        }}
      />
    </>
  );
}